export default __webpack_public_path__ + "ec75a1ad731fb6399bc5b4d2dc0bc12f.png";